import type { TracklistComment } from "@api/comments/types";
import { getSignature } from "@api/user";
import usePlay from "@layouts/App/context/Player/hooks/usePlay";
import { batch } from "solid-js";
import { createStore } from "solid-js/store";

const usePlayComments = () => {
	const [signatures, setSignatures] = createStore<Record<string, string>>({});
	const { playComments } = usePlay();

	return async (comments: TracklistComment[]) => {
		const userUids = new Set<string>();
		for (const c of comments) userUids.add(c.author.uid);
		const filtered = [...userUids].filter((uid) => !signatures[uid]);

		const res: string[] = [];
		for (const uid of filtered) {
			try {
				res.push((await getSignature(uid)).url);
			} catch {}
		}

		batch(() => {
			filtered.forEach((uid, index) => setSignatures(uid, res[index]));
		});
		playComments(comments, signatures);
	};
};
export default usePlayComments;
